/**
 * 设备检测工具函数
 */

/**
 * 检测当前设备是否为iPad
 * 
 * @returns {boolean} 如果是iPad设备返回true，否则返回false
 */
export function isIPad() {
  // 方法1：检查用户代理字符串中是否包含iPad
  const userAgent = navigator.userAgent;
  
  // 直接检测iPad
  if (/iPad/i.test(userAgent)) {
    return true;
  }
  
  // iOS 13+的iPad会伪装成Mac，需要额外检测
  // 在iOS 13+上，iPad的用户代理字符串变为类似Mac的格式
  // 但可以通过触摸点和屏幕尺寸特征来检测
  if (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1) {
    return true;
  }
  
  // 检查是否为Safari浏览器且存在已知问题
  // 这主要针对iPad上的Safari浏览器，它在语音识别方面有特定问题
  if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent) && 
      /AppleWebKit/i.test(userAgent) && navigator.maxTouchPoints > 1) {
    return true;
  }
  
  return false;
}

/**
 * 检测当前设备是否为iOS设备(iPhone或iPad)
 * 
 * @returns {boolean} 如果是iOS设备返回true，否则返回false
 */
export function isIOS() {
  const userAgent = navigator.userAgent;
  return /iPad|iPhone|iPod/i.test(userAgent) || 
         (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1);
}

/**
 * 检测当前浏览器是否为Safari
 * 
 * @returns {boolean} 如果是Safari浏览器返回true，否则返回false
 */
export function isSafari() {
  const userAgent = navigator.userAgent;
  return /Safari/i.test(userAgent) && !/Chrome/i.test(userAgent);
}

/**
 * 检测是否为iPad上的Safari浏览器，这种情况下语音识别可能存在问题
 * 
 * @returns {boolean} 如果是iPad上的Safari浏览器返回true，否则返回false
 */
export function isIPadSafari() {
  return isIPad() && isSafari();
}

/**
 * 记录iPad设备的详细信息，用于调试
 * 在控制台输出设备信息
 */
export function logDeviceInfo() {
  const userAgent = navigator.userAgent;
  const isIpad = isIPad();
  const isIOS_device = isIOS();
  const isSafariBrowser = isSafari();
  const isIPadSafariBrowser = isIPadSafari();
  
  console.log('===== 设备信息 =====');
  console.log('用户代理:', userAgent);
  console.log('是否为iPad:', isIpad);
  console.log('是否为iOS设备:', isIOS_device);
  console.log('是否为Safari浏览器:', isSafariBrowser);
  console.log('是否为iPad上的Safari浏览器:', isIPadSafariBrowser);
  console.log('触摸点数量:', navigator.maxTouchPoints);
  console.log('屏幕宽度:', window.screen.width);
  console.log('屏幕高度:', window.screen.height);
  console.log('窗口宽度:', window.innerWidth);
  console.log('窗口高度:', window.innerHeight);
  console.log('设备像素比:', window.devicePixelRatio);
  console.log('===================');
  
  // 检查语音识别API支持情况
  console.log('===== 语音识别支持 =====');
  console.log('SpeechRecognition支持:', 'SpeechRecognition' in window);
  console.log('webkitSpeechRecognition支持:', 'webkitSpeechRecognition' in window);
  
  // 检查Web Audio API支持情况
  console.log('===== Web Audio API支持 =====');
  console.log('AudioContext支持:', 'AudioContext' in window);
  console.log('webkitAudioContext支持:', 'webkitAudioContext' in window);
  console.log('MediaRecorder支持:', 'MediaRecorder' in window);
  console.log('getUserMedia支持:', 'mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices);
  
  return {
    userAgent,
    isIpad,
    isIOS: isIOS_device,
    isSafari: isSafariBrowser,
    isIPadSafari: isIPadSafariBrowser,
    maxTouchPoints: navigator.maxTouchPoints,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    speechRecognitionSupport: 'SpeechRecognition' in window || 'webkitSpeechRecognition' in window,
    webAudioSupport: 'AudioContext' in window || 'webkitAudioContext' in window,
    mediaRecorderSupport: 'MediaRecorder' in window,
    getUserMediaSupport: 'mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices
  };
} 